
import { has, get } from 'lodash';
import { sortByField } from './sorting';

/**
 * Take each entry and convert it into objects that can be used by components (i.e. selectByIdModal)
 * @param {Array} source the source array
 * @param {string} idField the id field to use
 * @param {string} nameField the name field to use
 * @param {boolean} selected is the item selected
 * @returns {Array} An array of objects that contain {id: string, name: string, selected: boolean, originalValue: boolean} or the source if input params are invalid
 */
export const selectorByIdBuilder = (source, idField, nameField, selected) => {
  try {
    if (Array.isArray(source) && idField && nameField) {
      return source.map(entry => {
        const id = has(entry, idField) ? get(entry, idField) : null;
        const name = has(entry, nameField) ? get(entry, nameField) : null;
        return { id, name, selected: selected || false, originalValue: selected || false };
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to convert the source to a selectable by id array '.concat(error));
    return [];
  }
  return [];
};

/**
 * 
 * @param {*} availableSelections Array of objects that contain id, name fields
 * @param {*} currentSelections Array of id's, used to determine what is selected in availableSelections
 */
export const mapDataToSelectionData = (availableSelections, currentSelections) => {
  let selectionList;
  let result = new Array();
  if (Array.isArray(availableSelections) && availableSelections?.length > 0) {
    const selectedList = new Array();
    let notSelectedList = new Array();
    if (Array.isArray(currentSelections) && currentSelections?.length > 0) {
      availableSelections?.forEach((selection) => {
        const found = currentSelections?.find((element) => element === selection?.id);
        if (found) {
          selectedList.push(selection);
        } else {
          notSelectedList.push(selection);
        }
      });
    } else {
      notSelectedList = availableSelections.slice();
    }
    selectionList = selectorByIdBuilder(selectedList, 'id', 'name', true);
    // sort the selections for display
    const notSelectedListSorted = sortByField(notSelectedList, 'name');
    const mappedNotLinkedSelections = selectorByIdBuilder(notSelectedListSorted, 'id', 'name', false);
    result = selectionList.concat(mappedNotLinkedSelections);
  }
  return result;
};


// WEBPACK FOOTER //
// ./services/selectors.js